<template>
  <error-page pageType="500"></error-page>
</template>

<script>
import ErrorPage from './ErrorPage'
export default {
  name: 'E500',
  components: {
    ErrorPage
  }
}
</script>
